import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Keycloak from 'keycloak-js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const keycloakConfig = environment.keycloak ?? {
  url: 'https://auth.k8dev.myafsa.com',
  realm: 'camunda-platform',
  clientId: 'back-office-client',
};

const keycloak = new Keycloak(keycloakConfig);

const idpHint = (environment.keycloak as { idpHint?: string } | undefined)?.idpHint ?? 'azure-ad';
const originalLogin = keycloak.login.bind(keycloak);
keycloak.login = (options?: { redirectUri?: string; [k: string]: unknown }) => {
  const result = originalLogin({ ...options, idpHint });
  return result ?? Promise.resolve();
};

keycloak
  .init({
    onLoad: 'login-required',
    checkLoginIframe: false,
    pkceMethod: 'S256',
  })
  .then(() => {
    (window as Window & { __keycloak?: typeof keycloak }).__keycloak = keycloak;
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  })
  .catch((err) => console.error('Keycloak init failed', err));
